<template>
	<section class="parceiros-container rounded-default p-4 cursor-pointer">
		<div class="flex flex-row justify-between">
			<span style="cursor: grab" class="item-grab">
				<i class="mdi mdi-drag fa-2x"></i>
			</span>
			<span class="partners-title">{{ data.ordem }} - {{ data.descricao }}</span>
			<span class="btn-edit flex justify-center items-center justify-center rounded-default">
				<span class="edit-icon" @click="$emit('selected', data.componente_id)">
					<feather type="edit-2" size="13px" />
				</span>

				<b-dropdown id="drop" class="trigger-dropdown" position="is-bottom-left" aria-role="list">
					<template #trigger>
						<div class="flex items-center justify-center">
							<feather class="actions-icon" type="chevron-down" size="14px" />
						</div>
					</template>

					<b-dropdown-item class="list-item">
						<span
							class="k-dropdown-item flex flex-row items-center justify-center"
							@click="dropdownActions(data)"
						>
							<span class="list-item-text">Deletar</span>
							<feather class="trash-icon" type="trash-2" size="14px" />
						</span>
					</b-dropdown-item>
				</b-dropdown>
			</span>
		</div>
		<div>
			<div class="row-container mt-2 mb-2 flex-row flex" style="gap: 10px; align-items: center">
				<div v-if="data.tipo.tipo_id">
					<img
						style="width: 400px; padding: 10px 0"
						class="image-layout-desc"
						:src="require(`@/views/componentes/layout-imagens/${data.tipo.tipo_id}.png`)"
						alt=""
					/>
				</div>
				<div class="row-container mt-2 mb-2" style="flex: 1">
					<span class="flex flex-row items-center justify-between item-row mb-5">
						<span class="identification">Tipo</span>
						<span class="item">{{ data.tipo.descricao }}</span>
					</span>
					<span class="flex flex-row items-center justify-between item-row mb-5">
						<span class="identification">Página</span>
						<span class="item">{{ data.pagina.rota }}</span>
					</span>
				</div>
				<!-- <span class="flex flex-row items-center justify-between item-row mb-5">
					<span class="identification">Última Alteração</span>
					<span class="item">{{ dateTimeToBrasil(data.updated_at) }}</span>
				</span>
				<span class="flex flex-row items-center justify-between item-row mb-5">
					<span class="identification">Ordem</span>
					<span class="item">{{ data.ordem }}</span>
				</span> -->
			</div>
		</div>
	</section>
</template>

<script>
import global from '@/mixins/global';

export default {
	name: 'Componente',
	mixins: [global],
	props: {
		data: {
			type: Object,
			required: true,
			default: () => ({}),
		},
	},
	data() {
		return {};
	},
	watch: {},
	methods: {
		dropdownActions(value) {
			this.$emit('dropdown-action', {
				action: 'delete',
				data: value,
			});
		},
	},
};
</script>

<style>
.dropdown-content {
	padding: 0px !important;
}
</style>

<style lang="scss" scoped>
@import '~@/style/Global.css';

.dropdown-item {
	padding: 5px !important;
}
.parceiros-container {
	background-color: var(--white-color);
	box-sizing: border-box;
	width: 100%;
	margin-bottom: 10px;
	transition: ease-in-out 0.2s;
	flex-wrap: wrap;
	border: 1px solid var(--secondary-color);
}

.btn-edit {
	background-color: var(--secondary-color);
	height: 30px;
	// overflow: hidden;
}

.trigger-dropdown,
.edit-icon {
	width: 50px;
	height: 30px;
	transition: ease-in-out 0.2s;
	display: flex;
	align-items: center;
	justify-content: center;
	&:hover {
		background-color: darken(#e2eaf5, 10%);
	}
}

.trash-icon {
	margin-left: 2px;
	color: #e63946;
}

.parceiros-container:hover {
	box-shadow: var(--default-shadow);
}

.list-item {
	display: flex;
	align-items: center;
	justify-content: center;
}

.item-row .identification {
	font-weight: 600;
	color: #666666;
}
.row-container {
	font-size: 12px;
}
.item-row {
	padding-bottom: 4px;
	margin-bottom: 6px;
	border-bottom: 2px solid var(--secondary-color);
}

.partners-title {
	font-weight: bold;
	font-size: 16px;
	color: #010101;
}
.list-item-text {
	font-size: 12px;
	font-weight: bold;
	color: #666666;
}
.k-dropdown-item {
	width: 100%;
	height: 100%;
}
</style>

